import { createI18n } from 'vue-i18n'
import getBrowserLocale from '@/util/get-browser-locale'

// Precompiled message functions, generated from the .json source files by
// scripts/precompile-locales.js via the prebuild/preserve npm hooks.
// vue-i18n 9 would otherwise compile each message at runtime with `new Function`,
// which the CSP forbids ('unsafe-eval' is not in script-src) - that throws
// EvalError inside every $t() and leaves the app rendering nothing.
import en from '@/locales/generated/en.js'
import de from '@/locales/generated/de.js'
import es from '@/locales/generated/es.js'
import pt from '@/locales/generated/pt.js'
import ptBR from '@/locales/generated/pt-br.js'

// Vuetify 3 owns its own strings now (see plugins/vuetify.js), so the `$vuetify`
// message namespace that used to be merged in here is gone.
const messages = { en, de, es, pt, ptBR }

export default createI18n({
  // Legacy mode keeps `this.$t` and `this.$root.$i18n.locale` working across the app
  // exactly as they did under vue-i18n 8.
  legacy: true,
  globalInjection: true,
  locale: process.env.VUE_APP_I18N_LOCALE || localStorage.getItem('locale') || getBrowserLocale({ countryCodeOnly: true }) || 'de',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'de',
  messages,
})
